<template>
  <div class="container">
    <div class="columns has-text-centered">
      <!-- number of blocks -->
      <div class="column has-text-centered sq">
        <div>
          <p class="is-size-2 title has-text-info">{{ $utils.addComma(chainStatus.blockHeight) }}</p>
          <p class="heading has-text-grey-light is-size-6">{{ $t("network.num_of_blocks") }}</p>
        </div>
      </div>
      <!-- lasttime of block mined -->
      <div class="column has-text-centered sq">
        <div>
          <p class="is-size-2 title has-text-info">{{ lastBlockTime }}</p>
          <p class="heading has-text-grey-light is-size-6">{{ $t("network.latest_block") }}</p>
        </div>
      </div>
      <!-- number of consensus peers -->
      <div class="column has-text-centered sq">
        <div>
          <p class="is-size-2 title has-text-info">1</p>
          <p class="heading has-text-grey-light is-size-6">{{ $t("network.consensus_peers") }}</p>
        </div>
      </div>
      <!-- transaction in seconds -->
      <div class="column has-text-centered sq">
        <div>
          <p class="is-size-2 title has-text-info">{{ transactionPerSecond }}</p>
          <p class="heading has-text-grey-light is-size-6">{{ $t("network.tx") }}</p>
        </div>
      </div>
    </div>
    <!-- tx sampler -->
    <line-chart :data="txDataForChart" :options="chartOptions"></line-chart>
  </div>
</template>

<script>
  import LineChart from './LineChart'
  import { mapState } from 'vuex'

  export default {
    name: 'network-status',
    components: { LineChart },
    data () {
      return {
        chartOptions: {
          animation: false,
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scaleOverride: true,
          scaleStepWidth: 1,
          scaleStartValue: 0
        }
      }
    },
    computed: {
      ...mapState(['chainStatus']),
      lastBlockTime () {
        if (this.chainStatus.lastBlockTime) {
          const last = this.chainStatus.lastBlockTime
          const d = new Date()
          const now = d.getTime()
          if (now / 1000 - last < 30) {
            return '' + parseInt(now / 1000 - last) + 's'
          } else {
            return this.$utils.fromNow(last)
          }
        } else {
          return 'n/a'
        }
      },
      transactionPerSecond () {
        return Number.parseFloat('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3)
      },
      txSamples () {
        let samples = this.chainStatus.txSamples.slice(0)
        samples = samples.filter(s => s !== null)
        samples.sort((a, b) => (a.timestamp === b.timestamp) ? 0 : (a.timestamp > b.timestamp) ? 1 : -1)
        return samples
      },
      txDataForChart () {
        return {
          labels: this.txSamples.map((d, i) => {
            if (i % 2 === 0) {
              return ''
            } else {
              return this.$utils.formatTimestamp(d.timestamp, 'HH:mm')
            }
          }),
          datasets: [
            {
              label: 'tx/s',
              fill: true,
              lineTension: 0.3,
              backgroundColor: 'rgba(75,192,192,0.4)',
              borderColor: 'rgba(75,192,192,1)',
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#000',
              pointBorderWidth: 5,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: 'rgba(75,192,192,1)',
              pointHoverBorderColor: 'rgba(220,220,220,1)',
              pointHoverBorderWidth: 2,
              pointRadius: 1,
              pointHitRadius: 10,
              data: this.txSamples.map(d => d.rate),
              spanGaps: true
            }
          ]
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sq {
    border: 1px solid #dbdbdb;
    padding-top: 2rem;
    padding-bottom: 2rem;
    margin: .8rem;

    p {
      margin-bottom: 1rem;
    }
  }

  .sq {
    position: relative;
    display: inline-block;
  }

  .sq:before,
  .sq:after,
  .sq>:first-child:before,
  .sq>:first-child:after {
    position: absolute;
    width: 25px;
    height: 25px;
    border-color: #bdbdbd;
    /* or whatever colour */
    border-style: solid;
    /* or whatever style */
    content: ' ';
    opacity: 0.55;
  }

  .sq:before {
    top: 0;
    left: 0;
    border-width: 2px 0 0 2px
  }

  .sq:after {
    top: 0;
    right: 0;
    border-width: 2px 2px 0 0
  }

  .sq>:first-child:before {
    bottom: 0;
    right: 0;
    border-width: 0 2px 2px 0
  }

  .sq>:first-child:after {
    bottom: 0;
    left: 0;
    border-width: 0 0 2px 2px
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/NetworkStatus.vue